import { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import styles from "./Link.module.scss";

interface ILinkProps {
    path: string;
    text: string;
    newTab?: boolean;
}

export const Link: FC<ILinkProps> = ({ path, text, newTab }) => {
    return (
        <RouterLink
            className={styles.link}
            to={path}
            target={newTab ? "_blank" : undefined}
            rel={newTab ? "noopener noreferrer" : undefined}
        >
            { text }
        </RouterLink>
    );
}